import { isSupabaseConfigured, supabase } from './supabase';

export type VisitorStats = {
  today: number;
  month: number;
  total: number;
};

function localDateKey(date = new Date()) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export async function recordSiteVisit() {
  const client = supabase;
  if (!isSupabaseConfigured || !client || typeof window === 'undefined') return;
  const key = `murta-visit-${localDateKey()}`;
  if (sessionStorage.getItem(key)) return;

  const { error } = await client.rpc('record_site_visit');
  if (!error) sessionStorage.setItem(key, '1');
}

export async function loadVisitorStats(): Promise<{ stats: VisitorStats | null; error?: string }> {
  const client = supabase;
  if (!isSupabaseConfigured || !client) return { stats: null, error: 'Supabase غير مربوط.' };

  const { data, error } = await client
    .from('site_visit_counters')
    .select('visit_date,count')
    .order('visit_date', { ascending: false });

  if (error) return { stats: null, error: error.message };

  const now = new Date();
  const todayKey = localDateKey(now);
  const monthPrefix = todayKey.slice(0, 7);
  let today = 0;
  let month = 0;
  let total = 0;

  for (const row of data || []) {
    const count = Number(row.count) || 0;
    total += count;
    if (row.visit_date === todayKey) today += count;
    if (String(row.visit_date).startsWith(monthPrefix)) month += count;
  }

  return { stats: { today, month, total } };
}
